export default __webpack_public_path__ + "static/image07-9187772fadd89f3b7e4ab298761f2704.webp";